import { Grid, Typography } from "@mui/material";
import { observer } from "mobx-react";
import React, { FunctionComponent } from "react";
import { Action } from "../../../../../models/Actions/Action";
import { EvalReviewActionMetadata } from "../../../../../models/Actions/Evaluation/EvalReviewActionMetadata";
import {
    parseFromISO,
    standardDateTimeFormat,
} from "../../../../../utils/DateTimeUtils";

interface OwnProps {
    request: Action<EvalReviewActionMetadata>;
}

type Props = OwnProps;

const RequestDetails: FunctionComponent<
    React.PropsWithChildren<React.PropsWithChildren<Props>>
> = observer((props) => {
    let actionRecipients;

    if (props.request.actionRecipients) {
        actionRecipients = props.request.actionRecipients.map(
            (recipient, index) =>
                `${
                    recipient.user?.userName
                        ? recipient.user.userName
                        : "Unknown"
                }${props.request?.actionRecipients?.[index + 1] ? ", " : ""}`,
        );
    }

    return (
        <>
            <Grid
                container
                justifyContent={"flex-start"}
                sx={{
                    paddingLeft: 3.5,
                    marginBottom: 1.5,
                }}
            >
                <Grid item xs={12}>
                    <Typography
                        sx={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            letterSpacing: "0",
                            lineHeight: "20px",
                        }}
                        variant={"subtitle1"}
                    >
                        {props.request.actionMetadata.parsedMetadata.reason}{" "}
                        Review
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <Typography
                        sx={{ fontSize: "12px" }}
                        variant={"subtitle2"}
                        color={"textSecondary"}
                    >
                        Started by {props.request.user.userName},{" "}
                        {standardDateTimeFormat(
                            parseFromISO(props.request.createdOn!),
                        )}
                    </Typography>
                </Grid>

                {props.request.actionRecipients &&
                    props.request.actionRecipients.length > 0 && (
                        <Grid item xs={12}>
                            <Typography
                                sx={{ fontSize: "12px" }}
                                variant="subtitle2"
                                color="textSecondary"
                            >
                                Action Recipients:
                            </Typography>

                            <Typography
                                sx={{ fontSize: "12px" }}
                                variant="subtitle2"
                                color="textSecondary"
                            >
                                {actionRecipients}
                            </Typography>
                        </Grid>
                    )}

                <Grid container sx={{ marginTop: 2 }}>
                    <Grid item lg={6} md={8} xs={11}>
                        <Typography>
                            {props.request.actionMetadata.parsedMetadata.notes}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
});

export default RequestDetails;
